import { InjectionToken } from '@angular/core';
import { ISfeConstants } from '../interfaces/i-sfe-constants';

export const SFE_CONSTANTS_TOKEN = new InjectionToken<ISfeConstants>('SFE_CONSTANTS_TOKEN', {
  providedIn: 'root',
  factory: () => ({
    appTitle: 'sfe-portal',
    keyApi: 'SfePortal',
    moduleTitle: 'Demo',
    companyFilter: 'global.company',
    dashboardService: 'dashboardService',
    qtdeTentativas: 'qtdeTentativas'
  })
});
